import MuiLink from '@mui/material/Link';
import { FC } from 'react';
import { useTheme } from '@emotion/react';
import { BrandedIcon } from '../../brandedIcon/BrandedIcon';
import { LinkProps } from './model/LinkProps';

const toTextDecoration = (disabled?: boolean, hasUnderLine?: boolean): string =>
  hasUnderLine && !disabled ? 'underline' : 'none';

export const Link: FC<LinkProps> = ({
  hasUnderLine = true,
  children,
  endIconName,
  startIconName,
  disabled,
  fontWeight = 400,
  sx,
  textDecorationColor = 'default',
  underline,
  ...props
}) => {
  const { palette } = useTheme();
  const component = props.component || props.href ? 'a' : 'button';
  const hasIcon = startIconName || endIconName;
  const underlineColor = textDecorationColor === 'error' ? palette.error.main : palette.text.primary;
  const underlineHoverColor = textDecorationColor === 'error' ? palette.error.dark : palette.text.primary;

  return (
    <MuiLink
      component={component}
      type={component === 'button' ? 'button' : undefined}
      disabled={disabled}
      underline={underline}
      sx={{
        display: hasIcon ? 'flex' : undefined,
        alignItems: hasIcon ? 'center' : undefined,
        color: disabled ? 'grey.600' : undefined,
        cursor: disabled ? 'default' : undefined,
        '&:hover, &:focus,&:active': {
          color: disabled ? 'grey.600' : undefined,
        },
        textDecoration: textDecorationColor === 'error' || underline === 'always' ? 'underline' : undefined,
        '&:hover': {
          textDecoration: toTextDecoration(disabled, hasUnderLine),
          textDecorationColor:
            disabled || textDecorationColor === 'default'
              ? undefined
              : textDecorationColor === 'error'
                ? underlineHoverColor
                : underlineColor,
          color: textDecorationColor === 'error' ? underlineHoverColor : undefined,
        },
        '&:hover span':
          textDecorationColor === 'error'
            ? {
                textDecorationColor: underlineHoverColor,
                color: underlineHoverColor,
              }
            : undefined,
        'span svg': {
          mr: startIconName ? 0.75 : 0,
          ml: endIconName ? 0.75 : 0,
        },
        fontWeight,
        ...sx,
      }}
      {...props}
    >
      {startIconName && <BrandedIcon name={startIconName} color={disabled ? 'disabled' : 'primary'} size="large" />}
      {children}
      {endIconName && <BrandedIcon name={endIconName} color={disabled ? 'disabled' : 'primary'} size="large" />}
    </MuiLink>
  );
};
